import { BottomSheet, useModalState } from "@clipboard-health/ui-components";
import { Button } from "@mui/material";
import { useToast } from "@src/appV2/lib";
import { NfcHashValidationAction } from "@src/appV2/redesign/WorkerShifts/Timekeeping/NfcValidation/api/types";
import { WorkerNfcValidation } from "@src/appV2/redesign/WorkerShifts/Timekeeping/NfcValidation/WorkerNfcValidation";
import { NfcTagRequestStatus } from "@src/appV2/Shifts/Shift/types";
import { useMemo } from "react";

/**
 * Debug page to test the NFC scanner
 */
export function NfcScannerDebugPage() {
  const modalState = useModalState();
  const { showInfoToast } = useToast();

  const randomNfcTagRequests = useMemo(() => {
    const predefinedTags = [
      { tagLocation: "Second Floor", tagStatus: NfcTagRequestStatus.SET_UP },
      { tagLocation: "Service Desk", tagStatus: NfcTagRequestStatus.SET_UP },
    ];
    const numberOfTags = Math.floor(Math.random() * (predefinedTags.length + 1));
    return Array.from({ length: numberOfTags }, (_, index) => {
      return predefinedTags[index % predefinedTags.length];
    });
  }, []);

  return (
    <>
      <Button
        fullWidth
        size="small"
        variant="outlined"
        color="warning"
        sx={{ color: "warning.main" }}
        onClick={modalState.openModal}
      >
        Debug NFC Scanner
      </Button>
      <BottomSheet modalState={modalState} canDismiss={false}>
        <WorkerNfcValidation
          isMissedPunchRequestEnabled={false}
          clockAction={NfcHashValidationAction.CLOCK_OUT}
          metaProps={{
            workerId: "67164818edc204d118670b8e",
            workplaceId: "67164818edc204d118670b8e",
            workplaceName: "Old Town Hospital",
          }}
          nfcTagRequests={randomNfcTagRequests}
          shiftId="67164818edc204d118670b8e"
          onSuccess={() => {
            showInfoToast("✅ NFC Scan Success");
            modalState.closeModal();
          }}
          onCancel={() => {
            showInfoToast("❌ NFC Scan Cancelled");
            modalState.closeModal();
          }}
          onSkipLocationCheck={() => {
            showInfoToast("⚠️ Skipped location check (non-instant pay)");
            modalState.closeModal();
          }}
          onNfcNotSupported={() => {
            showInfoToast("⚠️ NFC not supported on this device");
          }}
        />
      </BottomSheet>
    </>
  );
}
